import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LAB_RESULTS_FEATURE_KEY,
  State,
  LabResultsPartialState,
  labResultsAdapter
} from './lab-results.reducer';

export const getLabResultsState = createFeatureSelector<
  LabResultsPartialState,
  State
>(LAB_RESULTS_FEATURE_KEY);

const { selectAll, selectEntities } = labResultsAdapter.getSelectors();

export const getLabResultsLoading = createSelector(
  getLabResultsState,
  (state: State) => state.loading
);

export const getLabResultsSaving = createSelector(
  getLabResultsState,
  (state: State) => state.saving
);

export const getLabResultsCreating = createSelector(
  getLabResultsState,
  (state: State) => state.creating
);

export const getLabResultsError = createSelector(
  getLabResultsState,
  (state: State) => state.error
);

export const getAllLabResults = createSelector(
  getLabResultsState,
  (state: State) => selectAll(state)
);

export const getLabResultsEntities = createSelector(
  getLabResultsState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getLabResultsState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getLabResultsEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getLimitOffset = createSelector(
  getLabResultsState,
  (state: State) => ({ limit: state.limit, offset: state.offset })
);
